export const AI_PROMPT_CONFIG_KEY_LABELS: Record<string, string> = {
    DEFAULT_AI_EXTRACTOR_SYSTEM_PROMPT_ID: "Default AI extractor main prompt",
    DEFAULT_AI_REPORT_SUMMARY_PROMPT_ID: "Default report main prompt",
    INTEREST_EXTRACTOR_SYSTEM_PROMPT_ID: "Interest main prompt",
    INTEREST_EXTRACTOR_SUPPLEMENTARY_PROMPT_ID: "Interest additional instructions",
    INTEREST_MEMORY_SUGGEST_PROMPT_ID: "Interest memory suggest prompt"
};
